import ExpenseTyeRepository from '@/shared/http/repositories/configuration/expensetype.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'

export default {
  name: 'ModalNewDespesas',
  props: ['dataDetails'],
  data () {
    return {
      dataTypes: [],
      valorUnitario: 0,
      quantidade: 0,
      total: 0,
      idDespesaItem: '',
      observacao: '',
      form: {
        valorUnitario: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        quantidade: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        total: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      integerFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  mounted () {
    this.getAllTypes()
  },
  methods: {
    show () {
      this.$refs['add-newdespesa-modal'].show()
    },
    closeModal () {
      this.valorUnitario = 0
      this.quantidade = 0
      this.total = 0
      this.idDespesaItem = ''
      this.observacao = ''
      this.$refs['add-newdespesa-modal'].hide()
    },
    getAllTypes () {
      loading.push()
      ExpenseTyeRepository.GetAll()
        .then(Response => {
          this.dataTypes = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    calcularTotal () {
      let total = this.quantidade * this.valorUnitario
      this.total = total
    },
    save () {
      let data = {
        valorUnitario: this.valorUnitario,
        quantidade: this.quantidade,
        total: this.total,
        observacao: this.observacao,
        despesaTipoId: this.idDespesaItem
      }
      loading.push()
      ExpenseItemRepository.SetNewItem(this.dataDetails.id, data)
        .then(Response => {
          if (Response.data) {
            toast.success('Item incluido com sucesso!!')
          } else {
            toast.error('Naõ foi possivel incluir o item!!')
          }
          loading.pop()
          this.closeModal()
          this.$emit('reloadItem')
        })
        .catch(Error => loading.pop())
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/ModalNewDespesas/ModalNewDespesas.js